import { LocaleOption } from './types';

export const LOCALES: LocaleOption[] = [
  {
    code: 'en',
    label: 'English',
    country: 'United Kingdom',
    countryCode: 'GB',
  },
  {
    code: 'es',
    label: 'Español',
    country: 'España',
    countryCode: 'ES',
  },
  {
    code: 'pt',
    label: 'Português',
    country: 'Portugal',
    countryCode: 'PT',
  },
  {
    code: 'el',
    label: 'Ελληνικά',
    country: 'Ελλάδα',
    countryCode: 'GR',
  },
  {
    code: 'nl',
    label: 'Dutch',
    country: 'Nederland',
    countryCode: 'NL',
  },
  {
    code: 'de',
    label: 'Deutsch',
    country: 'Deutschland',
    countryCode: 'DE',
  },
  {
    code: 'et',
    label: 'Eesti keel',
    country: 'Eesti',
    countryCode: 'EE',
  },
];
